import { render } from "./SectorSelectView.vue?vue&type=template&id=33df71fe&scoped=true"
import script from "./SectorSelectView.vue?vue&type=script&lang=js"
export * from "./SectorSelectView.vue?vue&type=script&lang=js"

import "./SectorSelectView.vue?vue&type=style&index=0&id=33df71fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33df71fe"]])

export default __exports__